import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { leakEntries } from "@/mocks/leaks";

export default function HotRanking() {
  const ranking = [...leakEntries].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <section className="border-t border-background-200 bg-background-50">
      <div className="wrap py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              index="05"
              eyebrow="Most Read"
              title="本周阅读榜"
              desc="按 7 日内有效阅读量排序，每 24 小时更新一次。榜单只反映关注度，不代表可信等级。"
            />
            <Link
              to="/leaks"
              className="btn-base mt-6 border border-background-300 px-5 py-2.5 text-foreground-800 hover:border-primary-400 hover:text-primary-600"
            >
              查看更多线索
              <i className="ri-arrow-right-line text-base" />
            </Link>
          </div>

          <div className="lg:col-span-8">
            <ol className="border-t border-background-200">
              {ranking.map((entry, index) => (
                <li key={entry.id} className="border-b border-background-200">
                  <Link
                    to={`/leaks/${entry.id}`}
                    className="group flex items-start gap-4 py-5 md:gap-6"
                  >
                    <span
                      className={`font-heading text-2xl font-black tabular-nums md:text-3xl ${
                        index === 0 ? "text-primary-600" : "text-foreground-300"
                      }`}
                    >
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                        {entry.title}
                      </span>
                      <span className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2 font-label text-[11px] text-foreground-500">
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-price-tag-3-line" />
                          {entry.category}
                        </span>
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-eye-line" />
                          {entry.views.toLocaleString("zh-CN")} 阅读
                        </span>
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-chat-3-line" />
                          {entry.replies} 讨论
                        </span>
                      </span>
                    </span>
                    <span className="hidden h-8 w-8 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors group-hover:border-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 sm:flex">
                      <i className="ri-arrow-right-up-line" />
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}